import { render } from "./BgPage.vue?vue&type=template&id=6c982a20&scoped=true"
import script from "./BgPage.vue?vue&type=script&lang=js"
export * from "./BgPage.vue?vue&type=script&lang=js"

import "./BgPage.vue?vue&type=style&index=0&id=6c982a20&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c982a20"]])

export default __exports__